import template from "./card/template.jst";

import View from "backdraft-app/src/view";
import _ from "underscore";

class Card extends View {
  initialize(options) {
    super.initialize.apply(this, arguments);

    this.config = _.extend({}, this.defaultOptions, options.config);

    if (this.config.icon && this.config.spriteIcon) {
      throw new Error("Invalid argument. Must specify 'icon' or 'spriteIcon' but not both");
    }

    if (options.config.entireCardClickable && (options.config.button || options.config.buttonClasses)) {
      throw new Error("Invalid argument. Cannot specify 'entireCardClickable' and button config");
    }

    if (options.config.entireCardClickable && options.config.url) {
      throw new Error("Invalid argument. Cannot specify 'entireCardClickable' and 'url'");
    }

    if (options.config.entireCardClickable && !options.config.click) {
      throw new Error("Invalid argument. Must specify 'click' with 'entireCardClickable'");
    }

    this.filteredConfig = _.omit(this.config, (v, k, obj) => !_.includes(this.allowedConfig, k));

    if (this.filteredConfig.entireCardClickable) {
      this.$el.addClass("card--clickable");
    }
  }

  render() {
    this.$el.addClass(this.filteredConfig.classNames);
    this.$el.html(template({ config: this.filteredConfig }));

    if (this.filteredConfig.click) {
      const targetDom = this.config.entireCardClickable ? undefined : '.btn';

      this.$el.on('click', targetDom, evt => {
        this.filteredConfig.click.apply(this.parent);
        evt.preventDefault();
      });
    }

    return this;
  }
}

_.extend(Card.prototype, {
  className: "card",

  defaultOptions: {
    button:             'Select',
    buttonClasses:      'btn-primary',
    iconBackground:      true,
    classNames:          'col-auto',
    landscape:           false,
    entireCardClickable: false
  },

  allowedConfig: [
    "accentMessage",
    "button",
    "buttonClasses",
    "classNames",
    "click",
    "entireCardClickable",
    "icon",
    "iconBackground",
    "landscape",
    "message",
    "spriteIcon",
    "title",
    "url"
  ]
});

export default Card;
